var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widthFull " }, [
    _c("div", { staticClass: "widthFull headerBack section" }, [
      _c("div", { staticClass: "container dataContainer" }, [
        _c("div", { staticClass: "row justify-content-center " }, [
          _c("div", { staticClass: "col-md-6 " }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-6 pt-5 mt-5 text-md-right text-center" },
            [
              _c("img", {
                staticClass: "img-fluid widthFull",
                attrs: { src: require("../../assets/images/headerTitle.png") }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "scroll-to",
                      rawName: "v-scroll-to",
                      value: "#howplay",
                      expression: "'#howplay'"
                    }
                  ],
                  staticClass: "btn btn-primary btnYellow btn-lg mr-md-4 mt-5",
                  attrs: { type: "button" }
                },
                [_vm._v("SCOPRI DI PIÙ")]
              )
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "widthFull howplayBack section",
        attrs: { id: "howplay" }
      },
      [
        _c("div", { staticClass: "container " }, [
          _c("div", { staticClass: "row justify-content-center " }, [
            _c("div", { staticClass: "col-md-5 pt-5  center" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-7 pt-5 mb-5 center " }, [
              _c("img", {
                staticClass: "img-fluid widthFull pt-5 howPlayTitle",
                attrs: {
                  src: require("../../assets/images/how_play_title.png")
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "row justify-content-center align-items-center"
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _vm._m(2),
                  _vm._v(" "),
                  _vm._m(3),
                  _vm._v(" "),
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-6 center" },
                    [
                      _vm.hasPrev && _vm.isAuthenticated
                        ? _c(
                            "router-link",
                            {
                              staticClass:
                                "btn btn-primary btn-lg btnYellow mr-4 mt-2 ",
                              attrs: { to: "/calcolatore" }
                            },
                            [_vm._v("Calcolatore Preventivi")]
                          )
                        : !_vm.hasPrev && _vm.isAuthenticated
                        ? _c(
                            "router-link",
                            {
                              staticClass:
                                "btn btn-primary btn-lg btnYellow mr-4 mt-2 ",
                              attrs: { to: "/calcolatore" }
                            },
                            [_vm._v("Crea pratica")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "widthFull servicesBack section",
        attrs: { id: "services" }
      },
      [
        _c("div", { staticClass: "container " }, [
          _c("div", { staticClass: "row justify-content-center " }, [
            _c("div", { staticClass: "col-md-4 pt-5  center" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-8 pt-5 mb-5 center " }, [
              _c("img", {
                staticClass: "img-fluid widthFull pt-5 howPlayTitle",
                attrs: {
                  src: require("../../assets/images/services_tittle.png")
                }
              }),
              _vm._v(" "),
              _vm._m(5),
              _vm._v(" "),
              _vm._m(6),
              _vm._v(" "),
              _vm._m(7),
              _vm._v(" "),
              _vm._m(8),
              _vm._v(" "),
              _c("div", { staticClass: "row justify-content-right " }, [
                _c("div", { staticClass: "col-md-6 center" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-6 center" },
                  [
                    _vm.hasPrev && _vm.isAuthenticated
                      ? _c(
                          "router-link",
                          {
                            staticClass:
                              "btn btn-primary btn-lg btnYellow mr-4 mt-2 ",
                            attrs: { to: "/calcolatore" }
                          },
                          [_vm._v("Calcolatore Preventivi")]
                        )
                      : !_vm.hasPrev && _vm.isAuthenticated
                      ? _c(
                          "router-link",
                          {
                            staticClass:
                              "btn btn-primary btn-lg btnYellow mr-4 mt-2 ",
                            attrs: { to: "/calcolatore" }
                          },
                          [_vm._v("Crea pratica")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "howplayContainers center mt-5" }, [
        _c("img", {
          staticClass: "img-fluid widthFull widthFull howPlayImg",
          attrs: { src: require("../../assets/images/step1.png") }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "pl-2 pr-2 pb-2 noVisible" }, [
          _vm._v(
            "\r\n\t\t\t\t\t\t\t\t\tLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has\r\n\t\t\t\t\t\t\t\t\t been the industry's\r\n                  "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "howplayContainers center mt-5" }, [
        _c("img", {
          staticClass: "img-fluid widthFull widthFull howPlayImg",
          attrs: { src: require("../../assets/images/step2.png") }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "pl-2 pr-2 pb-2 noVisible" }, [
          _vm._v(
            "\r\n\t\t\t\t\t\t\t\t\tLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has\r\n\t\t\t\t\t\t\t\t\t been the industry's\r\n\t\t\t\t\t\t\t\t\t"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "howplayContainers center mt-1" }, [
        _c("img", {
          staticClass: "img-fluid widthFull widthFull howPlayImg",
          attrs: { src: require("../../assets/images/step3.png") }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "pl-2 pr-2 pb-2 noVisible" }, [
          _vm._v(
            "\r\n\t\t\t\t\t\t\t\t\tLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has\r\n\t\t\t\t\t\t\t\t\t been the industry's\r\n\t\t\t\t\t\t\t\t\t"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "howplayContainers center mt-1" }, [
        _c("img", {
          staticClass: "img-fluid widthFull widthFull howPlayImg",
          attrs: { src: require("../../assets/images/step4.png") }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "pl-2 pr-2 pb-2 noVisible" }, [
          _vm._v(
            "\r\n\t\t\t\t\t\t\t\t\tLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has\r\n\t\t\t\t\t\t\t\t\t been the industry's\r\n\t\t\t\t\t\t\t\t\t"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "howplayContainers center mt-1" }, [
        _c("img", {
          staticClass: "img-fluid widthFull widthFull howPlayImg",
          attrs: { src: require("../../assets/images/step5.png") }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "pl-2 pr-2 pb-2 noVisible" }, [
          _vm._v(
            "\r\n\t\t\t\t\t\t\t\t\tLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has\r\n\t\t\t\t\t\t\t\t\t been the industry's\r\n\t\t\t\t\t\t\t\t\t"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center pt-5 pb-3" }, [
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: " center" }, [
          _c("img", {
            staticClass: "img-fluid widthFull widthFull ",
            attrs: { src: require("../../assets/images/service1.png") }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "text-left" }, [
          _c("p", { staticClass: "pl-2 pr-2 black smallDesc" }, [
            _c("strong", { staticClass: "h4 black" }, [
              _c("b", [_vm._v("BONUS CASA")])
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(
              "Lavori di ristrutturazione di abitazioni e parti comuni di edifici residenziali\r\n                  Per saperne di più\r\n                  "
            ),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "yellow link green underline",
                attrs: { target: "_blank", href: "https://www" }
              },
              [_vm._v(" Per saperne di più")]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center pb-3" }, [
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: " center" }, [
          _c("img", {
            staticClass: "img-fluid widthFull widthFull ",
            attrs: { src: require("../../assets/images/service2.png") }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "text-left" }, [
          _c("p", { staticClass: "pl-2 pr-2 black smallDesc" }, [
            _c("strong", { staticClass: "h4 black" }, [
              _c("b", [_vm._v("ECOBONUS")])
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(
              "interventi di riqualificazione energetica degli edifici esistenti: sostituzione della vecchia caldaia con una caldaia a condensazione in classe A,\r\n                  installazione di pannelli solari  o sostituzione di impianti di riscaldamento con pompe di calore ad alta efficienza ed impianti geotermici a bassa entalpia.\r\n                  "
            ),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "yellow green link underline",
                attrs: { target: "_blank", href: "https://www" }
              },
              [_vm._v(" Per saperne di più")]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center pb-3" }, [
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: " center" }, [
          _c("img", {
            staticClass: "img-fluid widthFull widthFull ",
            attrs: { src: require("../../assets/images/service3.png") }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "text-left" }, [
          _c("p", { staticClass: "pl-2 pr-2 black  smallDesc" }, [
            _c("strong", { staticClass: "h4 black" }, [
              _c("b", [_vm._v("ECOBONUS")])
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(
              "interventi di riqualificazione energetica degli edifici esistenti: sostituzione della vecchia caldaia con una caldaia a condensazione in classe A\r\n                   abbinata a sistemi di termoregolazione evoluti (appartenenti alle classi V, VI o VIII), installazione di pannelli solari  o sostituzione di impianti di\r\n                  riscaldamento con pompe di calore ad alta efficienza ed impianti geotermici a bassa entalpia .\r\n                  "
            ),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "yellow link green underline",
                attrs: { target: "_blank", href: "https://www" }
              },
              [_vm._v(" Per saperne di più")]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center pb-3" }, [
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: " center" }, [
          _c("img", {
            staticClass: "img-fluid widthFull widthFull ",
            attrs: { src: require("../../assets/images/service4.png") }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "text-left" }, [
          _c("p", { staticClass: "pl-2 pr-2 black smallDesc" }, [
            _c("strong", { staticClass: "h4 black" }, [
              _c("b", [_vm._v("SUPERBONUS")])
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(
              "Detrazione per le spese sostenute per specifici interventi di riqualificazione energetica dal 1° luglio 2020 al 31 dicembre 2021\r\n                  "
            ),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "yellow link green underline",
                attrs: { target: "_blank", href: "https://www" }
              },
              [_vm._v(" Per saperne di più")]
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67f3a69c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67f3a69c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/index.vue
// module id = null
// module chunks = 